import { render, staticRenderFns } from "./RetoureModals.vue?vue&type=template&id=6647ac2f&scoped=true"
import script from "./RetoureModals.vue?vue&type=script&lang=js"
export * from "./RetoureModals.vue?vue&type=script&lang=js"
import style0 from "./RetoureModals.vue?vue&type=style&index=0&id=6647ac2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647ac2f",
  null
  
)

export default component.exports